












import { Component, Prop, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FileUtil from '@/util/FileUtil';

@Component({})
export default class SampleDocument extends mixins(FileUtil) {
  @Prop({}) fileHeadline!: string;

  @Prop({}) file!: any;

  public downloadAgreement() {
    this.downloadStaticFile(this.file);
  }
}
